const applicationStatistics = [
  {
    attribute: 'totalApplications',
    labels: ['Candidature', 'Candidatures'],
    titleClasses: 'text-h5 font-weight-bold',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-clipboard-account-outline',
    iconColor: 'primary'
  },
  {
    attribute: 'totalCanceledApplications',
    labels: ['Candidature annulée', 'Candidatures annulées'],
    titleClasses: 'text-h5 font-weight-bold',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-cancel',
    iconColor: 'primary'
  },
  {
    attribute: 'offersWithApplications',
    labels: ['Offre sans candidature', 'Offres sans candidature'],
    titleClasses: 'text-h5 font-weight-bold',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-book-alert',
    iconColor: 'primary'
  },
  { attribute: 'source' },
  {
    attribute: 'recruiterStatus',
    type: 'value',
    titleClasses: 'subtitle-1',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-account-tie',
    iconColor: 'primary'
  },
  {
    attribute: 'validatedPromisesHistogram',
    type: 'validatedPromisesHistogram'
  },
  {
    attribute: 'totalAverage',
    type: 'totalAverage',
    titleClasses: 'text-h5 font-weight-bold',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-clock-check-outline',
    iconColor: 'primary'
  },
  {
    attribute: 'topOffersWithApplications',
    type: 'topOffersWithApplications',
    labels: ['Offre', 'Offres'],
    icon: 'mdi-podium',
    iconColor: 'primary',
    component: 'Metric'
  }
];

const offerStatistics = [
  {
    attribute: 'offers',
    labels: ['Offre', 'Offres'],
    titleClasses: 'text-h5 font-weight-bold',
    subtitleClasses: 'subtitle-1 overline',
    icon: 'mdi-book-multiple',
    iconColor: 'primary'
  },
  {
    attribute: 'status',
    type: 'value',
    publishedLabels: ['Publiée', 'Publiées'],
    draftedLabels: ['Brouillon', 'Brouillons'],
    publishedColor: 'lightGreen',
    draftedColor: 'lightGray'
  }
];

export { applicationStatistics, offerStatistics };
